import { useMemo } from 'react';
import { NavLink } from 'react-router';
import Settings from '@components/Settings/Settings';
import { ROUTER_ITEMS } from '@constants/routerItems.constant';
import styles from './FeaturesList.module.css';

const FeaturesList = () => {
  const featuresList = useMemo(() => {
    return Object.values(ROUTER_ITEMS).map((route) => ({
      id: route.path,
      name: route.title,
      path: route.path,
      icon: route.icon
    }));
  }, []);

  return (
    <nav className={styles.featuresList}>
      <ul>
        {featuresList.map((item) => (
          <li key={item.id}>
            <NavLink to={item.path} title={item.name}>
              {item.icon}
            </NavLink>
          </li>
        ))}
        <li>
          <Settings />
        </li>
      </ul>
    </nav>
  );
};

export default FeaturesList;
